import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

const CTASection = ({ onContactClick }) => {
  return (
    <section
      id="cta"
      data-testid="cta-section"
      className="relative py-20 md:py-32 px-5 md:px-12 lg:px-20 bg-black border-t border-white/5 overflow-hidden"
    >
      {/* Subtle gradient accent */}
      <div className="absolute bottom-0 left-0 w-full h-1/2 bg-gradient-to-t from-[#6DBE2E]/[0.02] to-transparent pointer-events-none" />
      
      <div className="max-w-6xl mx-auto relative">
        <div className="max-w-xl">
          <p className="text-[#6DBE2E] text-[11px] md:text-xs font-medium tracking-[0.2em] uppercase mb-4 md:mb-6">
            Next Step
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-medium text-white leading-tight tracking-tight mb-6 md:mb-8">
            Let's see if there's a fit.
          </h2>
          
          <p className="text-white/50 text-base md:text-lg mb-8 md:mb-10 leading-relaxed">
            No pitch. No pressure. Just a conversation about what you're trying to build 
            and whether Harlem Leads can help you get there.
          </p>
          
          <Button
            onClick={onContactClick}
            data-testid="cta-main-btn"
            className="premium-btn bg-[#6DBE2E] text-black hover:bg-[#5CAD25] rounded-none font-semibold px-6 md:px-8 py-5 md:py-6 text-sm group"
          >
            Start a Conversation
            <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform duration-300" />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
